import { useFlags, useFlagsmithLoading } from '@flagsmith/flagsmith/react';
import {
  FEATURE_FLAG,
  type FeatureFlagName,
} from '@/feature-flags/feature-flags.constants';

/** Map rollout requires current server configuration; menu flags keep their own cache policy. */
export function useCompoundMapRollout(): boolean {
  const flag = useFlags<FeatureFlagName>([
    FEATURE_FLAG.commandCentreCompoundMap,
  ])[FEATURE_FLAG.commandCentreCompoundMap];
  const loading = useFlagsmithLoading();
  // A refresh in flight retains the last successful server state. Errors revoke it.
  return Boolean(
    loading &&
      !loading.isLoading &&
      !loading.error &&
      loading.source === 'SERVER' &&
      flag?.enabled === true,
  );
}
